/**
 * RESPONSIBILITY: one sermon as a card — picture, title, speaker and date, scripture.
 *
 * The whole card is the link to the sermon's own page, where the notes and questions
 * are; the video plays there too. Its picture is the one uploaded for it, or YouTube's.
 */
import { hasImage } from '@framework/core';
import type { SermonRow } from '@app/sections';
import { Picture } from '../commons/Picture';
import { YoutubeThumb } from '../commons/YoutubeThumb';
import { NotPublic } from '../commons/NotPublic';
import { sermonHref } from './sermon-href';
import { sermonDay, sermonName } from './sermon-day';

export function SermonCard({ s }: { s: SermonRow }) {
  const meta = [s.speaker, sermonDay(s.preachedOn)].filter(Boolean);
  return (
    <a className="sermon-card" href={sermonHref(s)}>
      <span className="sermon-video">
        {hasImage(s.image)
          ? <Picture value={s.image} alt="" />
          : <YoutubeThumb url={s.youtubeUrl} alt="" />}
      </span>
      {s.show === false && <NotPublic />}
      <h3 className="sermon-title">{sermonName(s)}</h3>
      {meta.length > 0 && <p className="sermon-meta">{meta.join(' · ')}</p>}
      {s.scripture && <p className="sermon-scripture">{s.scripture}</p>}
    </a>
  );
}
